export type BackupFormat = 'JSON' | 'CSV';
export type BackupStatus = 'IN_PROGRESS' | 'DONE' | 'FAILED';

export interface AccountBackupStatus {
  jobId: string; // UUID
  status: BackupStatus;
  format: BackupFormat;
  downloadUrl: string | null; // set only when status === 'DONE'
  startedAt: string; // ISO datetime
  finishedAt: string | null; // ISO datetime, set when DONE or FAILED
}

export interface AccountBackupRequest {
  format: BackupFormat;
  from?: string | null; // 'YYYY-MM-DD'
  to?: string | null; // 'YYYY-MM-DD'
}
